import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-table-metadata-cols mt-2" },
    [
      _c(
        VRow,
        { staticClass: "mb-1", attrs: { dense: "", align: "center" } },
        [
          _c(
            VCol,
            [
              _c(VTextField, {
                attrs: {
                  outlined: "",
                  small: "",
                  dense: "",
                  placeholder: _vm.$t("my_tasks.modals.type_search"),
                  "prepend-inner-icon": "icon-search",
                  loading: _vm.isLoadingSearch,
                  "hide-details": "",
                },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.onSearchInput($event)
                  },
                },
                model: {
                  value: _vm.inputSearch,
                  callback: function ($$v) {
                    _vm.inputSearch = $$v
                  },
                  expression: "inputSearch",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            { attrs: { cols: "auto" } },
            [
              _c(
                VBtnToggle,
                {
                  attrs: { mandatory: "", dense: "", rounded: "" },
                  model: {
                    value: _vm.viewMode,
                    callback: function ($$v) {
                      _vm.viewMode = $$v
                    },
                    expression: "viewMode",
                  },
                },
                [
                  _c(
                    VBtn,
                    {
                      attrs: {
                        value: "table",
                        small: "",
                        title: "Vista tabla",
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-table"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: {
                        value: "expanded",
                        small: "",
                        title: "Vista expandible",
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-view-list"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.viewMode === "table"
        ? [
            _vm._m(0),
            _c(VDataTable, {
              key: "table-" + _vm.key_table,
              staticClass: "table-inca table-reference",
              attrs: {
                striped: "",
                responsive: "",
                items: _vm.displayColumnFields,
                headers: _vm.headers,
                "per-page": _vm.perPage,
                "current-page": _vm.currentPage,
                "no-border-collapse": true,
                "sticky-header": true,
                "item-class": _vm.rowClassSensitive,
                search: _vm.searchFilter,
                page: _vm.pagination.current,
                "items-per-page": _vm.pagination.limit,
                "hide-default-footer": true,
                "custom-sort": _vm.customSort,
              },
              on: {
                "update:page": function ($event) {
                  return _vm.$set(_vm.pagination, "current", $event)
                },
                pagination: function ($event) {
                  _vm.pagination.total = $event.itemsLength
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "head(fields_type_stringValue)",
                    fn: function (data) {
                      return [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover.top",
                                value: "Data types are at the logical level",
                                expression:
                                  "'Data types are at the logical level'",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                          },
                          [_vm._v(_vm._s(data.label))]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.fields_null_boolValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.fields[_vm.DEFAULT_TPL_COLUMNS.NULL.name]
                          ? _c(VCheckbox, {
                              staticClass: "ml-3",
                              class: _vm.classColumnDiff(
                                item.column,
                                _vm.DEFAULT_TPL_COLUMNS.NULL.name
                              ),
                              attrs: {
                                value: true,
                                disabled:
                                  _vm.lockSchemaColumns ||
                                  !_vm.isEdited("COLUMN_FIELD"),
                                pattern: _vm.getPattern(
                                  _vm.DEFAULT_TPL_COLUMNS.NULL
                                ),
                                small: "",
                                dense: "",
                              },
                              model: {
                                value:
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.NULL.name
                                  ][_vm.DEFAULT_TPL_COLUMNS.NULL.type],
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.NULL.name
                                    ],
                                    _vm.DEFAULT_TPL_COLUMNS.NULL.type,
                                    $$v
                                  )
                                },
                                expression:
                                  "item.fields[DEFAULT_TPL_COLUMNS.NULL.name][DEFAULT_TPL_COLUMNS.NULL.type]",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.include_in_flow",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        !_vm.isRequestView
                          ? _c(VCheckbox, {
                              staticClass: "ml-3",
                              attrs: {
                                small: "",
                                dense: "",
                                value: item.included,
                                disabled: "",
                                size: "sm",
                              },
                              model: {
                                value: item.included,
                                callback: function ($$v) {
                                  _vm.$set(item, "included", $$v)
                                },
                                expression: "item.included",
                              },
                            })
                          : item.fields[_vm.DEFAULT_TPL_COLUMNS.SENSITIVE.name]
                          ? _c(VCheckbox, {
                              staticClass: "ml-3",
                              attrs: {
                                small: "",
                                dense: "",
                                value: _vm.ACCESS_TYPE_FLOW.INCLUDED,
                                "unchecked-value":
                                  _vm.ACCESS_TYPE_FLOW.NOT_INCLUDED,
                                disabled: !_vm.isEnable(item),
                                pattern: _vm.getPattern(
                                  _vm.DEFAULT_TPL_COLUMNS.SENSITIVE
                                ),
                                size: "sm",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onSelectItem($event)
                                },
                              },
                              model: {
                                value:
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.SENSITIVE.name
                                  ].include_in_flow,
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.SENSITIVE.name
                                    ],
                                    "include_in_flow",
                                    $$v
                                  )
                                },
                                expression:
                                  "item.fields[DEFAULT_TPL_COLUMNS.SENSITIVE.name].include_in_flow",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.fields_sensitive_boolValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.fields[_vm.DEFAULT_TPL_COLUMNS.SENSITIVE.name]
                          ? _c(VCheckbox, {
                              staticClass: "ml-4",
                              class: _vm.classColumnDiff(
                                item.column,
                                _vm.DEFAULT_TPL_COLUMNS.SENSITIVE.name
                              ),
                              attrs: {
                                small: "",
                                dense: "",
                                value: true,
                                disabled: !_vm.isEdited("COLUMN_FIELD"),
                                pattern: _vm.getPattern(
                                  _vm.DEFAULT_TPL_COLUMNS.SENSITIVE
                                ),
                                size: "sm",
                              },
                              model: {
                                value:
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.SENSITIVE.name
                                  ][_vm.DEFAULT_TPL_COLUMNS.SENSITIVE.type],
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.SENSITIVE.name
                                    ],
                                    _vm.DEFAULT_TPL_COLUMNS.SENSITIVE.type,
                                    $$v
                                  )
                                },
                                expression:
                                  "item.fields[DEFAULT_TPL_COLUMNS.SENSITIVE.name][DEFAULT_TPL_COLUMNS.SENSITIVE.type]",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.primary_key_boolValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.fields[_vm.DEFAULT_TPL_COLUMNS.PRIMARY_KEY.name]
                          ? _c(VCheckbox, {
                              staticClass: "ml-4",
                              class: _vm.classColumnDiff(
                                item.column,
                                _vm.DEFAULT_TPL_COLUMNS.PRIMARY_KEY.name
                              ),
                              attrs: {
                                small: "",
                                dense: "",
                                value: true,
                                disabled: !_vm.isEdited("COLUMN_FIELD"),
                                pattern: _vm.getPattern(
                                  _vm.DEFAULT_TPL_COLUMNS.PRIMARY_KEY
                                ),
                                size: "sm",
                              },
                              model: {
                                value:
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.PRIMARY_KEY.name
                                  ][_vm.DEFAULT_TPL_COLUMNS.PRIMARY_KEY.type],
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.PRIMARY_KEY.name
                                    ],
                                    _vm.DEFAULT_TPL_COLUMNS.PRIMARY_KEY.type,
                                    $$v
                                  )
                                },
                                expression:
                                  "item.fields[DEFAULT_TPL_COLUMNS.PRIMARY_KEY.name][DEFAULT_TPL_COLUMNS.PRIMARY_KEY.type]",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.fields_business_definition_stringValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          VTooltip,
                          {
                            attrs: { right: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    return [
                                      item.fields[
                                        _vm.DEFAULT_TPL_COLUMNS
                                          .BUSINESS_DEFINITION.name
                                      ]
                                        ? _c(
                                            VTextarea,
                                            _vm._g(
                                              {
                                                class: _vm.classColumnDiff(
                                                  item.column,
                                                  _vm.DEFAULT_TPL_COLUMNS
                                                    .BUSINESS_DEFINITION.name
                                                ),
                                                attrs: {
                                                  small: "",
                                                  dense: "",
                                                  filled:
                                                    !_vm.isEdited(
                                                      "COLUMN_FIELD"
                                                    ),
                                                  outlined:
                                                    _vm.isEdited(
                                                      "COLUMN_FIELD"
                                                    ),
                                                  "hide-details": "auto",
                                                  rows: "1",
                                                  "auto-grow": "",
                                                  size: "sm",
                                                  type: "text",
                                                  placeholder: "Describe...",
                                                  readonly:
                                                    !_vm.isEdited(
                                                      "COLUMN_FIELD"
                                                    ),
                                                  required: _vm.getRequired(
                                                    _vm.DEFAULT_TPL_COLUMNS
                                                      .BUSINESS_DEFINITION
                                                  ),
                                                  pattern: _vm.getPattern(
                                                    _vm.DEFAULT_TPL_COLUMNS
                                                      .BUSINESS_DEFINITION
                                                  ),
                                                  rules: _vm.isEdited(
                                                    "COLUMN_FIELD"
                                                  )
                                                    ? _vm.rulesBusinessDefinition
                                                    : [],
                                                },
                                                model: {
                                                  value:
                                                    item.fields[
                                                      _vm.DEFAULT_TPL_COLUMNS
                                                        .BUSINESS_DEFINITION
                                                        .name
                                                    ][
                                                      _vm.DEFAULT_TPL_COLUMNS
                                                        .BUSINESS_DEFINITION
                                                        .type
                                                    ],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item.fields[
                                                        _vm.DEFAULT_TPL_COLUMNS
                                                          .BUSINESS_DEFINITION
                                                          .name
                                                      ],
                                                      _vm.DEFAULT_TPL_COLUMNS
                                                        .BUSINESS_DEFINITION
                                                        .type,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.fields[DEFAULT_TPL_COLUMNS.BUSINESS_DEFINITION.name][DEFAULT_TPL_COLUMNS.BUSINESS_DEFINITION.type]",
                                                },
                                              },
                                              on
                                            )
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.BUSINESS_DEFINITION
                                      .name
                                  ][
                                    _vm.DEFAULT_TPL_COLUMNS.BUSINESS_DEFINITION
                                      .type
                                  ]
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.fields_data_element_name_stringValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          VTooltip,
                          {
                            attrs: { right: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    return [
                                      item.fields[
                                        _vm.DEFAULT_TPL_COLUMNS
                                          .DATA_ELEMENT_NAME.name
                                      ]
                                        ? _c(
                                            VTextarea,
                                            _vm._g(
                                              {
                                                class: _vm.classColumnDiff(
                                                  item.column,
                                                  _vm.DEFAULT_TPL_COLUMNS
                                                    .DATA_ELEMENT_NAME.name
                                                ),
                                                attrs: {
                                                  small: "",
                                                  dense: "",
                                                  filled:
                                                    !_vm.isEdited(
                                                      "COLUMN_FIELD"
                                                    ),
                                                  outlined:
                                                    _vm.isEdited(
                                                      "COLUMN_FIELD"
                                                    ),
                                                  "hide-details": "auto",
                                                  rows: "1",
                                                  "auto-grow": "",
                                                  size: "sm",
                                                  type: "text",
                                                  placeholder: "Describe...",
                                                  required: _vm.getRequired(
                                                    _vm.DEFAULT_TPL_COLUMNS
                                                      .DATA_ELEMENT_NAME
                                                  ),
                                                  readonly:
                                                    !_vm.isEdited(
                                                      "COLUMN_FIELD"
                                                    ),
                                                  pattern: _vm.getPattern(
                                                    _vm.DEFAULT_TPL_COLUMNS
                                                      .DATA_ELEMENT_NAME
                                                  ),
                                                },
                                                model: {
                                                  value:
                                                    item.fields[
                                                      _vm.DEFAULT_TPL_COLUMNS
                                                        .DATA_ELEMENT_NAME.name
                                                    ][
                                                      _vm.DEFAULT_TPL_COLUMNS
                                                        .DATA_ELEMENT_NAME.type
                                                    ],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item.fields[
                                                        _vm.DEFAULT_TPL_COLUMNS
                                                          .DATA_ELEMENT_NAME
                                                          .name
                                                      ],
                                                      _vm.DEFAULT_TPL_COLUMNS
                                                        .DATA_ELEMENT_NAME.type,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.fields[DEFAULT_TPL_COLUMNS.DATA_ELEMENT_NAME.name][DEFAULT_TPL_COLUMNS.DATA_ELEMENT_NAME.type]",
                                                },
                                              },
                                              on
                                            )
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.DATA_ELEMENT_NAME
                                      .name
                                  ][
                                    _vm.DEFAULT_TPL_COLUMNS.DATA_ELEMENT_NAME
                                      .type
                                  ]
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.fields_length_stringValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm.lockSchemaColumns &&
                        item.fields[_vm.DEFAULT_TPL_COLUMNS.LENGTH.name]
                          ? _c(
                              "span",
                              {
                                class: _vm.classColumnDiff(
                                  item.column,
                                  _vm.DEFAULT_TPL_COLUMNS.LENGTH.name
                                ),
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.LENGTH.name
                                    ][_vm.DEFAULT_TPL_COLUMNS.LENGTH.type]
                                  )
                                ),
                              ]
                            )
                          : item.fields[_vm.DEFAULT_TPL_COLUMNS.LENGTH.name]
                          ? _c(VTextarea, {
                              class: _vm.classColumnDiff(
                                item.column,
                                _vm.DEFAULT_TPL_COLUMNS.LENGTH.name
                              ),
                              attrs: {
                                small: "",
                                dense: "",
                                filled: !_vm.isEdited("COLUMN_FIELD"),
                                outlined: _vm.isEdited("COLUMN_FIELD"),
                                "hide-details": "auto",
                                rows: "1",
                                "auto-grow": "",
                                size: "sm",
                                type: "text",
                                readonly: !_vm.isEdited("COLUMN_FIELD"),
                                required: false,
                                pattern: _vm.getPattern(
                                  _vm.DEFAULT_TPL_COLUMNS.LENGTH
                                ),
                                min: "0",
                              },
                              model: {
                                value:
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.LENGTH.name
                                  ][_vm.DEFAULT_TPL_COLUMNS.LENGTH.type],
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.LENGTH.name
                                    ],
                                    _vm.DEFAULT_TPL_COLUMNS.LENGTH.type,
                                    $$v
                                  )
                                },
                                expression:
                                  "item.fields[DEFAULT_TPL_COLUMNS.LENGTH.name][DEFAULT_TPL_COLUMNS.LENGTH.type]",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.fields_transformation_logic_stringValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.fields[
                          _vm.DEFAULT_TPL_COLUMNS.TRANSFORMATION_LOGIC.name
                        ]
                          ? _c(VTextarea, {
                              class: _vm.classColumnDiff(
                                item.column,
                                _vm.DEFAULT_TPL_COLUMNS.TRANSFORMATION_LOGIC
                                  .name
                              ),
                              attrs: {
                                small: "",
                                dense: "",
                                filled: !_vm.isEdited("COLUMN_FIELD"),
                                outlined: _vm.isEdited("COLUMN_FIELD"),
                                "hide-details": "auto",
                                rows: "1",
                                "auto-grow": "",
                                size: "sm",
                                type: "text",
                                placeholder: "Describe...",
                                readonly: !_vm.isEdited("COLUMN_FIELD"),
                                required: _vm.getRequired(
                                  _vm.DEFAULT_TPL_COLUMNS.TRANSFORMATION_LOGIC
                                ),
                                pattern: _vm.getPattern(
                                  _vm.DEFAULT_TPL_COLUMNS.TRANSFORMATION_LOGIC
                                ),
                              },
                              model: {
                                value:
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.TRANSFORMATION_LOGIC
                                      .name
                                  ][
                                    _vm.DEFAULT_TPL_COLUMNS.TRANSFORMATION_LOGIC
                                      .type
                                  ],
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS
                                        .TRANSFORMATION_LOGIC.name
                                    ],
                                    _vm.DEFAULT_TPL_COLUMNS.TRANSFORMATION_LOGIC
                                      .type,
                                    $$v
                                  )
                                },
                                expression:
                                  "item.fields[DEFAULT_TPL_COLUMNS.TRANSFORMATION_LOGIC.name][DEFAULT_TPL_COLUMNS.TRANSFORMATION_LOGIC.type]",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.fields_type_stringValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm.lockSchemaColumns &&
                        item.fields[_vm.DEFAULT_TPL_COLUMNS.TYPE.name]
                          ? _c(
                              "span",
                              {
                                class: _vm.classColumnDiff(
                                  item.column,
                                  _vm.DEFAULT_TPL_COLUMNS.TYPE.name
                                ),
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.TYPE.name
                                    ][_vm.DEFAULT_TPL_COLUMNS.TYPE.type]
                                  )
                                ),
                              ]
                            )
                          : item.fields[_vm.DEFAULT_TPL_COLUMNS.TYPE.name]
                          ? _c(VTextarea, {
                              class: _vm.classColumnDiff(
                                item.column,
                                _vm.DEFAULT_TPL_COLUMNS.TYPE.name
                              ),
                              attrs: {
                                small: "",
                                dense: "",
                                filled: !_vm.isEdited("COLUMN_FIELD"),
                                outlined: _vm.isEdited("COLUMN_FIELD"),
                                "hide-details": "auto",
                                rows: "1",
                                "auto-grow": "",
                                size: "sm",
                                type: "text",
                                placeholder: "Describe...",
                                readonly: !_vm.isEdited("COLUMN_FIELD"),
                                required: _vm.getRequired(
                                  _vm.DEFAULT_TPL_COLUMNS.TYPE
                                ),
                                pattern: _vm.getPattern(
                                  _vm.DEFAULT_TPL_COLUMNS.TYPE
                                ),
                              },
                              model: {
                                value:
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.TYPE.name
                                  ][_vm.DEFAULT_TPL_COLUMNS.TYPE.type],
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.TYPE.name
                                    ],
                                    _vm.DEFAULT_TPL_COLUMNS.TYPE.type,
                                    $$v
                                  )
                                },
                                expression:
                                  "item.fields[DEFAULT_TPL_COLUMNS.TYPE.name][DEFAULT_TPL_COLUMNS.TYPE.type]",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.fields_valid_values_stringValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.fields[_vm.DEFAULT_TPL_COLUMNS.VALID_VALUES.name]
                          ? _c(VTextarea, {
                              class: _vm.classColumnDiff(
                                item.column,
                                _vm.DEFAULT_TPL_COLUMNS.VALID_VALUES.name
                              ),
                              attrs: {
                                small: "",
                                dense: "",
                                filled: !_vm.isEdited("COLUMN_FIELD"),
                                outlined: _vm.isEdited("COLUMN_FIELD"),
                                "hide-details": "auto",
                                rows: "1",
                                "auto-grow": "",
                                size: "sm",
                                type: "text",
                                placeholder: "Describe...",
                                readonly: !_vm.isEdited("COLUMN_FIELD"),
                                required: _vm.getRequired(
                                  _vm.DEFAULT_TPL_COLUMNS.VALID_VALUES
                                ),
                                pattern: _vm.getPattern(
                                  _vm.DEFAULT_TPL_COLUMNS.VALID_VALUES
                                ),
                              },
                              model: {
                                value:
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.VALID_VALUES.name
                                  ][_vm.DEFAULT_TPL_COLUMNS.VALID_VALUES.type],
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.VALID_VALUES.name
                                    ],
                                    _vm.DEFAULT_TPL_COLUMNS.VALID_VALUES.type,
                                    $$v
                                  )
                                },
                                expression:
                                  "item.fields[DEFAULT_TPL_COLUMNS.VALID_VALUES.name][DEFAULT_TPL_COLUMNS.VALID_VALUES.type]",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.fields_encrypted_boolValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(VCheckbox, {
                          staticClass: "ml-4",
                          class: _vm.classColumnDiff(
                            item.column,
                            _vm.DEFAULT_TPL_COLUMNS.ENCRYPTED.name
                          ),
                          attrs: {
                            small: "",
                            dense: "",
                            value: true,
                            disabled: !_vm.isEdited("COLUMN_FIELD"),
                            required: _vm.getRequired(
                              _vm.DEFAULT_TPL_COLUMNS.ENCRYPTED
                            ),
                            pattern: _vm.getPattern(
                              _vm.DEFAULT_TPL_COLUMNS.ENCRYPTED
                            ),
                            size: "sm",
                          },
                          model: {
                            value:
                              item.fields[
                                _vm.DEFAULT_TPL_COLUMNS.ENCRYPTED.name
                              ][_vm.DEFAULT_TPL_COLUMNS.ENCRYPTED.type],
                            callback: function ($$v) {
                              _vm.$set(
                                item.fields[
                                  _vm.DEFAULT_TPL_COLUMNS.ENCRYPTED.name
                                ],
                                _vm.DEFAULT_TPL_COLUMNS.ENCRYPTED.type,
                                $$v
                              )
                            },
                            expression:
                              "item.fields[DEFAULT_TPL_COLUMNS.ENCRYPTED.name][DEFAULT_TPL_COLUMNS.ENCRYPTED.type]",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "item.fields_load_logic_stringValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.fields[
                          _vm.DEFAULT_TPL_COLUMNS.COLUMN_LOAD_LOGIC.name
                        ]
                          ? _c(VTextField, {
                              staticClass: "ml-4",
                              class: _vm.classColumnDiff(
                                item.column,
                                _vm.DEFAULT_TPL_COLUMNS.COLUMN_LOAD_LOGIC.name
                              ),
                              attrs: {
                                filled: !_vm.isEdited("COLUMN_FIELD"),
                                outlined: _vm.isEdited("COLUMN_FIELD"),
                                small: "",
                                dense: "",
                                type: "text",
                                disabled: !_vm.isEdited("COLUMN_FIELD"),
                                required: _vm.getRequired(
                                  _vm.DEFAULT_TPL_COLUMNS.COLUMN_LOAD_LOGIC
                                ),
                                pattern: _vm.getPattern(
                                  _vm.DEFAULT_TPL_COLUMNS.COLUMN_LOAD_LOGIC
                                ),
                                size: "sm",
                              },
                              model: {
                                value:
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.COLUMN_LOAD_LOGIC
                                      .name
                                  ][
                                    _vm.DEFAULT_TPL_COLUMNS.COLUMN_LOAD_LOGIC
                                      .type
                                  ],
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.COLUMN_LOAD_LOGIC
                                        .name
                                    ],
                                    _vm.DEFAULT_TPL_COLUMNS.COLUMN_LOAD_LOGIC
                                      .type,
                                    $$v
                                  )
                                },
                                expression:
                                  "item.fields[DEFAULT_TPL_COLUMNS.COLUMN_LOAD_LOGIC.name][DEFAULT_TPL_COLUMNS.COLUMN_LOAD_LOGIC.type]",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ],
                null,
                false,
                1117814092
              ),
            }),
          ]
        : _vm._e(),
      _vm.viewMode === "expanded"
        ? [
            _c(VDataTable, {
              key: "exp-" + _vm.key_table,
              staticClass: "table-inca",
              staticStyle: { cursor: "pointer" },
              attrs: {
                items: _vm.displayColumnFields,
                headers: _vm.summaryHeaders,
                expanded: _vm.expanded,
                "single-expand": "",
                "show-expand": "",
                "item-key": "column",
                search: _vm.searchFilter,
                page: _vm.pagination.current,
                "items-per-page": _vm.pagination.limit,
                "hide-default-footer": true,
                "custom-sort": _vm.customSort,
                "item-class": _vm.rowClassSensitive,
              },
              on: {
                "update:expanded": function ($event) {
                  _vm.expanded = $event
                },
                "update:page": function ($event) {
                  return _vm.$set(_vm.pagination, "current", $event)
                },
                pagination: function ($event) {
                  _vm.pagination.total = $event.itemsLength
                },
                "click:row": _vm.onClickRow,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "item.include_in_flow",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        !_vm.isRequestView
                          ? _c(VCheckbox, {
                              staticClass: "ml-3",
                              attrs: {
                                small: "",
                                dense: "",
                                value: item.included,
                                disabled: "",
                                size: "sm",
                              },
                              model: {
                                value: item.included,
                                callback: function ($$v) {
                                  _vm.$set(item, "included", $$v)
                                },
                                expression: "item.included",
                              },
                            })
                          : item.fields[_vm.DEFAULT_TPL_COLUMNS.SENSITIVE.name]
                          ? _c(VCheckbox, {
                              staticClass: "ml-3",
                              attrs: {
                                small: "",
                                dense: "",
                                value: _vm.ACCESS_TYPE_FLOW.INCLUDED,
                                "unchecked-value":
                                  _vm.ACCESS_TYPE_FLOW.NOT_INCLUDED,
                                disabled: !_vm.isEnable(item),
                                pattern: _vm.getPattern(
                                  _vm.DEFAULT_TPL_COLUMNS.SENSITIVE
                                ),
                                size: "sm",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onSelectItem($event)
                                },
                              },
                              model: {
                                value:
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.SENSITIVE.name
                                  ].include_in_flow,
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.SENSITIVE.name
                                    ],
                                    "include_in_flow",
                                    $$v
                                  )
                                },
                                expression:
                                  "item.fields[DEFAULT_TPL_COLUMNS.SENSITIVE.name].include_in_flow",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.fields_data_element_name_stringValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.fields[
                          _vm.DEFAULT_TPL_COLUMNS.DATA_ELEMENT_NAME.name
                        ]
                          ? _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c(VTextarea, {
                                  class: _vm.classColumnDiff(
                                    item.column,
                                    _vm.DEFAULT_TPL_COLUMNS.DATA_ELEMENT_NAME
                                      .name
                                  ),
                                  attrs: {
                                    small: "",
                                    dense: "",
                                    rows: "1",
                                    "auto-grow": "",
                                    "hide-details": "",
                                    filled: !_vm.isEdited("COLUMN_FIELD"),
                                    outlined: _vm.isEdited("COLUMN_FIELD"),
                                    type: "text",
                                    placeholder: "Describe...",
                                    readonly: !_vm.isEdited("COLUMN_FIELD"),
                                    required: _vm.getRequired(
                                      _vm.DEFAULT_TPL_COLUMNS.DATA_ELEMENT_NAME
                                    ),
                                    pattern: _vm.getPattern(
                                      _vm.DEFAULT_TPL_COLUMNS.DATA_ELEMENT_NAME
                                    ),
                                  },
                                  model: {
                                    value:
                                      item.fields[
                                        _vm.DEFAULT_TPL_COLUMNS
                                          .DATA_ELEMENT_NAME.name
                                      ][
                                        _vm.DEFAULT_TPL_COLUMNS
                                          .DATA_ELEMENT_NAME.type
                                      ],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        item.fields[
                                          _vm.DEFAULT_TPL_COLUMNS
                                            .DATA_ELEMENT_NAME.name
                                        ],
                                        _vm.DEFAULT_TPL_COLUMNS
                                          .DATA_ELEMENT_NAME.type,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "item.fields[DEFAULT_TPL_COLUMNS.DATA_ELEMENT_NAME.name][DEFAULT_TPL_COLUMNS.DATA_ELEMENT_NAME.type]",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.fields_type_stringValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm.lockSchemaColumns &&
                        item.fields[_vm.DEFAULT_TPL_COLUMNS.TYPE.name]
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.TYPE.name
                                  ][_vm.DEFAULT_TPL_COLUMNS.TYPE.type]
                                )
                              ),
                            ])
                          : item.fields[_vm.DEFAULT_TPL_COLUMNS.TYPE.name]
                          ? _c(VTextarea, {
                              class: _vm.classColumnDiff(
                                item.column,
                                _vm.DEFAULT_TPL_COLUMNS.TYPE.name
                              ),
                              staticStyle: { "max-width": "110px" },
                              attrs: {
                                small: "",
                                dense: "",
                                rows: "1",
                                "auto-grow": "",
                                "hide-details": "",
                                filled: !_vm.isEdited("COLUMN_FIELD"),
                                outlined: _vm.isEdited("COLUMN_FIELD"),
                                readonly: !_vm.isEdited("COLUMN_FIELD"),
                                pattern: _vm.getPattern(
                                  _vm.DEFAULT_TPL_COLUMNS.TYPE
                                ),
                              },
                              model: {
                                value:
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.TYPE.name
                                  ][_vm.DEFAULT_TPL_COLUMNS.TYPE.type],
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.TYPE.name
                                    ],
                                    _vm.DEFAULT_TPL_COLUMNS.TYPE.type,
                                    $$v
                                  )
                                },
                                expression:
                                  "item.fields[DEFAULT_TPL_COLUMNS.TYPE.name][DEFAULT_TPL_COLUMNS.TYPE.type]",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.fields_length_stringValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm.lockSchemaColumns &&
                        item.fields[_vm.DEFAULT_TPL_COLUMNS.LENGTH.name]
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.LENGTH.name
                                  ][_vm.DEFAULT_TPL_COLUMNS.LENGTH.type]
                                )
                              ),
                            ])
                          : item.fields[_vm.DEFAULT_TPL_COLUMNS.LENGTH.name]
                          ? _c(
                              "div",
                              {
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                              },
                              [
                                _c(VTextField, {
                                  class: _vm.classColumnDiff(
                                    item.column,
                                    _vm.DEFAULT_TPL_COLUMNS.LENGTH.name
                                  ),
                                  staticStyle: { "max-width": "70px" },
                                  attrs: {
                                    small: "",
                                    dense: "",
                                    "hide-details": "",
                                    filled: !_vm.isEdited("COLUMN_FIELD"),
                                    outlined: _vm.isEdited("COLUMN_FIELD"),
                                    readonly: !_vm.isEdited("COLUMN_FIELD"),
                                    pattern: _vm.getPattern(
                                      _vm.DEFAULT_TPL_COLUMNS.LENGTH
                                    ),
                                  },
                                  model: {
                                    value:
                                      item.fields[
                                        _vm.DEFAULT_TPL_COLUMNS.LENGTH.name
                                      ][_vm.DEFAULT_TPL_COLUMNS.LENGTH.type],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        item.fields[
                                          _vm.DEFAULT_TPL_COLUMNS.LENGTH.name
                                        ],
                                        _vm.DEFAULT_TPL_COLUMNS.LENGTH.type,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "item.fields[DEFAULT_TPL_COLUMNS.LENGTH.name][DEFAULT_TPL_COLUMNS.LENGTH.type]",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.fields_sensitive_boolValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.fields[_vm.DEFAULT_TPL_COLUMNS.SENSITIVE.name]
                          ? _c(VCheckbox, {
                              staticClass: "ml-2",
                              class: _vm.classColumnDiff(
                                item.column,
                                _vm.DEFAULT_TPL_COLUMNS.SENSITIVE.name
                              ),
                              attrs: {
                                small: "",
                                dense: "",
                                "hide-details": "",
                                value: true,
                                disabled: !_vm.isEdited("COLUMN_FIELD"),
                                pattern: _vm.getPattern(
                                  _vm.DEFAULT_TPL_COLUMNS.SENSITIVE
                                ),
                              },
                              model: {
                                value:
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.SENSITIVE.name
                                  ][_vm.DEFAULT_TPL_COLUMNS.SENSITIVE.type],
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.SENSITIVE.name
                                    ],
                                    _vm.DEFAULT_TPL_COLUMNS.SENSITIVE.type,
                                    $$v
                                  )
                                },
                                expression:
                                  "item.fields[DEFAULT_TPL_COLUMNS.SENSITIVE.name][DEFAULT_TPL_COLUMNS.SENSITIVE.type]",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.fields_null_boolValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.fields[_vm.DEFAULT_TPL_COLUMNS.NULL.name]
                          ? _c(VCheckbox, {
                              staticClass: "ml-2",
                              class: _vm.classColumnDiff(
                                item.column,
                                _vm.DEFAULT_TPL_COLUMNS.NULL.name
                              ),
                              attrs: {
                                small: "",
                                dense: "",
                                "hide-details": "",
                                value: true,
                                disabled:
                                  _vm.lockSchemaColumns ||
                                  !_vm.isEdited("COLUMN_FIELD"),
                                pattern: _vm.getPattern(
                                  _vm.DEFAULT_TPL_COLUMNS.NULL
                                ),
                              },
                              model: {
                                value:
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.NULL.name
                                  ][_vm.DEFAULT_TPL_COLUMNS.NULL.type],
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.NULL.name
                                    ],
                                    _vm.DEFAULT_TPL_COLUMNS.NULL.type,
                                    $$v
                                  )
                                },
                                expression:
                                  "item.fields[DEFAULT_TPL_COLUMNS.NULL.name][DEFAULT_TPL_COLUMNS.NULL.type]",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.primary_key_boolValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.fields[_vm.DEFAULT_TPL_COLUMNS.PRIMARY_KEY.name]
                          ? _c(VCheckbox, {
                              staticClass: "ml-2",
                              class: _vm.classColumnDiff(
                                item.column,
                                _vm.DEFAULT_TPL_COLUMNS.PRIMARY_KEY.name
                              ),
                              attrs: {
                                small: "",
                                dense: "",
                                "hide-details": "",
                                value: true,
                                disabled: !_vm.isEdited("COLUMN_FIELD"),
                                pattern: _vm.getPattern(
                                  _vm.DEFAULT_TPL_COLUMNS.PRIMARY_KEY
                                ),
                              },
                              model: {
                                value:
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.PRIMARY_KEY.name
                                  ][_vm.DEFAULT_TPL_COLUMNS.PRIMARY_KEY.type],
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.PRIMARY_KEY.name
                                    ],
                                    _vm.DEFAULT_TPL_COLUMNS.PRIMARY_KEY.type,
                                    $$v
                                  )
                                },
                                expression:
                                  "item.fields[DEFAULT_TPL_COLUMNS.PRIMARY_KEY.name][DEFAULT_TPL_COLUMNS.PRIMARY_KEY.type]",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.fields_encrypted_boolValue",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        item.fields[_vm.DEFAULT_TPL_COLUMNS.ENCRYPTED.name]
                          ? _c(VCheckbox, {
                              staticClass: "ml-2",
                              class: _vm.classColumnDiff(
                                item.column,
                                _vm.DEFAULT_TPL_COLUMNS.ENCRYPTED.name
                              ),
                              attrs: {
                                small: "",
                                dense: "",
                                "hide-details": "",
                                value: true,
                                disabled: !_vm.isEdited("COLUMN_FIELD"),
                                pattern: _vm.getPattern(
                                  _vm.DEFAULT_TPL_COLUMNS.ENCRYPTED
                                ),
                              },
                              model: {
                                value:
                                  item.fields[
                                    _vm.DEFAULT_TPL_COLUMNS.ENCRYPTED.name
                                  ][_vm.DEFAULT_TPL_COLUMNS.ENCRYPTED.type],
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.ENCRYPTED.name
                                    ],
                                    _vm.DEFAULT_TPL_COLUMNS.ENCRYPTED.type,
                                    $$v
                                  )
                                },
                                expression:
                                  "item.fields[DEFAULT_TPL_COLUMNS.ENCRYPTED.name][DEFAULT_TPL_COLUMNS.ENCRYPTED.type]",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "expanded-item",
                    fn: function (ref) {
                      var headers = ref.headers
                      var item = ref.item
                      return [
                        _c(
                          "td",
                          {
                            staticClass: "expanded-item-panel",
                            staticStyle: {
                              padding: "8px 20px 20px",
                              background: "#f8fbff",
                              "border-bottom": "2px solid #1565c0",
                            },
                            attrs: {
                              colspan: headers.length,
                              "data-column": item.column,
                            },
                          },
                          [
                            _c(
                              VRow,
                              {
                                staticClass: "pt-1 pb-2",
                                attrs: { dense: "" },
                              },
                              [
                                _c(
                                  VCol,
                                  { attrs: { cols: "12", sm: "6" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-bold caption mb-1",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "my_tasks.modals.bdefinition"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS
                                        .BUSINESS_DEFINITION.name
                                    ]
                                      ? _c(VTextarea, {
                                          class: _vm.classColumnDiff(
                                            item.column,
                                            _vm.DEFAULT_TPL_COLUMNS
                                              .BUSINESS_DEFINITION.name
                                          ),
                                          attrs: {
                                            small: "",
                                            dense: "",
                                            rows: "2",
                                            "auto-grow": "",
                                            filled:
                                              !_vm.isEdited("COLUMN_FIELD"),
                                            outlined:
                                              _vm.isEdited("COLUMN_FIELD"),
                                            "hide-details": "auto",
                                            type: "text",
                                            placeholder: "Describe...",
                                            readonly:
                                              !_vm.isEdited("COLUMN_FIELD"),
                                            required: _vm.getRequired(
                                              _vm.DEFAULT_TPL_COLUMNS
                                                .BUSINESS_DEFINITION
                                            ),
                                            pattern: _vm.getPattern(
                                              _vm.DEFAULT_TPL_COLUMNS
                                                .BUSINESS_DEFINITION
                                            ),
                                            rules: _vm.isEdited("COLUMN_FIELD")
                                              ? _vm.rulesBusinessDefinition
                                              : [],
                                          },
                                          model: {
                                            value:
                                              item.fields[
                                                _vm.DEFAULT_TPL_COLUMNS
                                                  .BUSINESS_DEFINITION.name
                                              ][
                                                _vm.DEFAULT_TPL_COLUMNS
                                                  .BUSINESS_DEFINITION.type
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.fields[
                                                  _vm.DEFAULT_TPL_COLUMNS
                                                    .BUSINESS_DEFINITION.name
                                                ],
                                                _vm.DEFAULT_TPL_COLUMNS
                                                  .BUSINESS_DEFINITION.type,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.fields[DEFAULT_TPL_COLUMNS.BUSINESS_DEFINITION.name][DEFAULT_TPL_COLUMNS.BUSINESS_DEFINITION.type]",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "12", sm: "6" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-bold caption mb-1",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "my_tasks.modals.valid_values"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.VALID_VALUES.name
                                    ]
                                      ? _c(VTextarea, {
                                          class: _vm.classColumnDiff(
                                            item.column,
                                            _vm.DEFAULT_TPL_COLUMNS.VALID_VALUES
                                              .name
                                          ),
                                          attrs: {
                                            small: "",
                                            dense: "",
                                            rows: "2",
                                            "auto-grow": "",
                                            filled:
                                              !_vm.isEdited("COLUMN_FIELD"),
                                            outlined:
                                              _vm.isEdited("COLUMN_FIELD"),
                                            "hide-details": "auto",
                                            type: "text",
                                            placeholder: "Describe...",
                                            readonly:
                                              !_vm.isEdited("COLUMN_FIELD"),
                                            required: _vm.getRequired(
                                              _vm.DEFAULT_TPL_COLUMNS
                                                .VALID_VALUES
                                            ),
                                            pattern: _vm.getPattern(
                                              _vm.DEFAULT_TPL_COLUMNS
                                                .VALID_VALUES
                                            ),
                                          },
                                          model: {
                                            value:
                                              item.fields[
                                                _vm.DEFAULT_TPL_COLUMNS
                                                  .VALID_VALUES.name
                                              ][
                                                _vm.DEFAULT_TPL_COLUMNS
                                                  .VALID_VALUES.type
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.fields[
                                                  _vm.DEFAULT_TPL_COLUMNS
                                                    .VALID_VALUES.name
                                                ],
                                                _vm.DEFAULT_TPL_COLUMNS
                                                  .VALID_VALUES.type,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.fields[DEFAULT_TPL_COLUMNS.VALID_VALUES.name][DEFAULT_TPL_COLUMNS.VALID_VALUES.type]",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "12", sm: "6" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-bold caption mb-1",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("my_tasks.modals.load_logic")
                                          )
                                        ),
                                      ]
                                    ),
                                    item.fields[
                                      _vm.DEFAULT_TPL_COLUMNS.COLUMN_LOAD_LOGIC
                                        .name
                                    ]
                                      ? _c(VTextarea, {
                                          class: _vm.classColumnDiff(
                                            item.column,
                                            _vm.DEFAULT_TPL_COLUMNS
                                              .COLUMN_LOAD_LOGIC.name
                                          ),
                                          attrs: {
                                            small: "",
                                            dense: "",
                                            rows: "2",
                                            "auto-grow": "",
                                            filled:
                                              !_vm.isEdited("COLUMN_FIELD"),
                                            outlined:
                                              _vm.isEdited("COLUMN_FIELD"),
                                            "hide-details": "auto",
                                            readonly:
                                              !_vm.isEdited("COLUMN_FIELD"),
                                            required: _vm.getRequired(
                                              _vm.DEFAULT_TPL_COLUMNS
                                                .COLUMN_LOAD_LOGIC
                                            ),
                                            pattern: _vm.getPattern(
                                              _vm.DEFAULT_TPL_COLUMNS
                                                .COLUMN_LOAD_LOGIC
                                            ),
                                          },
                                          model: {
                                            value:
                                              item.fields[
                                                _vm.DEFAULT_TPL_COLUMNS
                                                  .COLUMN_LOAD_LOGIC.name
                                              ][
                                                _vm.DEFAULT_TPL_COLUMNS
                                                  .COLUMN_LOAD_LOGIC.type
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item.fields[
                                                  _vm.DEFAULT_TPL_COLUMNS
                                                    .COLUMN_LOAD_LOGIC.name
                                                ],
                                                _vm.DEFAULT_TPL_COLUMNS
                                                  .COLUMN_LOAD_LOGIC.type,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.fields[DEFAULT_TPL_COLUMNS.COLUMN_LOAD_LOGIC.name][DEFAULT_TPL_COLUMNS.COLUMN_LOAD_LOGIC.type]",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                !_vm.hideTransformationLogic
                                  ? _c(
                                      VCol,
                                      { attrs: { cols: "12", sm: "6" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "font-weight-bold caption mb-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "my_tasks.modals.transformation_logic"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        item.fields[
                                          _vm.DEFAULT_TPL_COLUMNS
                                            .TRANSFORMATION_LOGIC.name
                                        ]
                                          ? _c(VTextarea, {
                                              class: _vm.classColumnDiff(
                                                item.column,
                                                _vm.DEFAULT_TPL_COLUMNS
                                                  .TRANSFORMATION_LOGIC.name
                                              ),
                                              attrs: {
                                                small: "",
                                                dense: "",
                                                rows: "2",
                                                "auto-grow": "",
                                                filled:
                                                  !_vm.isEdited("COLUMN_FIELD"),
                                                outlined:
                                                  _vm.isEdited("COLUMN_FIELD"),
                                                "hide-details": "auto",
                                                type: "text",
                                                placeholder: "Describe...",
                                                readonly:
                                                  !_vm.isEdited("COLUMN_FIELD"),
                                                required: _vm.getRequired(
                                                  _vm.DEFAULT_TPL_COLUMNS
                                                    .TRANSFORMATION_LOGIC
                                                ),
                                                pattern: _vm.getPattern(
                                                  _vm.DEFAULT_TPL_COLUMNS
                                                    .TRANSFORMATION_LOGIC
                                                ),
                                              },
                                              model: {
                                                value:
                                                  item.fields[
                                                    _vm.DEFAULT_TPL_COLUMNS
                                                      .TRANSFORMATION_LOGIC.name
                                                  ][
                                                    _vm.DEFAULT_TPL_COLUMNS
                                                      .TRANSFORMATION_LOGIC.type
                                                  ],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item.fields[
                                                      _vm.DEFAULT_TPL_COLUMNS
                                                        .TRANSFORMATION_LOGIC
                                                        .name
                                                    ],
                                                    _vm.DEFAULT_TPL_COLUMNS
                                                      .TRANSFORMATION_LOGIC
                                                      .type,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.fields[DEFAULT_TPL_COLUMNS.TRANSFORMATION_LOGIC.name][DEFAULT_TPL_COLUMNS.TRANSFORMATION_LOGIC.type]",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                3081093629
              ),
            }),
          ]
        : _vm._e(),
      _vm.isLoadingColumns
        ? _c(VProgressLinear, {
            attrs: { indeterminate: "", color: "primary" },
          })
        : _vm._e(),
      _vm.lazyLoadParams && _vm.isChangeRequest === "VIEWER_ONLY"
        ? _c("pagination-firestore", {
            key: "page-" + _vm.key_table,
            attrs: { pagination: _vm.pagination, pageType: "1" },
            on: { changePagina: _vm.changePage },
          })
        : _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "wrapper2" } }, [
      _c("div", { staticClass: "width-scroll", attrs: { id: "div2" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }